const history = require('./src/muster-history/src');
module.exports = history;
